module.exports = __webpack_public_path__ + "static/auto_policy_updates_mobile-ae391780054fbd05b956539dba88eb32.png";